import { formatDocument } from "../../../utils/utils";

const Sociedade = ({ socios, canFormatDocument = true }) => {
  return (
    <>
      <div className="mt-3 overflow-hidden rounded-2xl border border-slate-200 bg-white">
        <div className="border-b border-slate-200 bg-slate-50 px-4 py-3">
          <div className="grid grid-cols-7 gap-2 text-[10px] font-semibold uppercase tracking-[0.28em] text-slate-500">
            <div className="text-center">Nº</div>
            <div className="col-span-2">Nome</div>
            <div className="text-center">CPF</div>
            <div className="text-center">Cargo</div>
            <div className="text-center">Part. (%)</div>
            <div className="text-center">Restrição</div>
          </div>
        </div>

        {socios?.length > 0 && (
          <div className="divide-y divide-slate-100">
            {socios?.map((socio, index) => (
              <div
                key={index}
                className={`grid grid-cols-7 gap-2 px-4 py-3 text-sm items-center ${
                  index % 2 === 0 ? "bg-white" : "bg-slate-50/40"
                } hover:bg-slate-50`}
              >
                <div className="text-center font-medium text-slate-700">
                  {index + 1}
                </div>
                <div className="col-span-2">
                  <div className="font-medium text-slate-900">
                    {socio?.nome || "-"}
                  </div>
                </div>
                <div className="text-center text-slate-700">
                  {socio?.cpf
                    ? canFormatDocument
                      ? formatDocument(socio?.cpf)
                      : socio?.cpf
                    : "-"}
                </div>
                <div className="text-center text-slate-700">
                  {socio?.cargo || "-"}
                </div>
                <div className="text-center text-slate-700">
                  {socio?.participacaoEmPorcentagem ||
                    socio?.percentualParticipacao ||
                    "-"}
                </div>
                <div className="text-center text-slate-700">
                  {socio?.temRestricoes == null
                    ? "-"
                    : socio.temRestricoes
                    ? "Sim"
                    : "Não"}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default Sociedade;
